/**
 * CRA env flags for the Budget Refactor migration.
 * Defaults are false unless the corresponding REACT_APP_* var is exactly "true".
 *
 * @see docs/BudgetRefactor/backlog.agent.md §5
 */
export const featureFlags = {
  /** GET /v2/budget?project= summary list instead of full GET /budget/get */
  useV2BudgetList: process.env.REACT_APP_USE_V2_BUDGET_LIST === "true",
  /**
   * Editor bootstrap from v2 shell + services (FE-P3-01).
   * `GET /v2/budget/:id` + drained `GET /v2/budget/:id/services`.
   * Flag off: v1 `GET /budget/get?id=` only.
   */
  useV2BudgetDetail: process.env.REACT_APP_USE_V2_BUDGET_DETAIL === "true",
  /**
   * Editor autosave via v2 service writes (FE-P3-03 / FE-P3-04).
   * Default false. When true: field edits → debounced batch PATCH; create /
   * delete / move → POST/DELETE (moves = delete+create); totals/config → slim
   * v1 PUT. Header/tax still full v1 PUT. When false: full-document v1 PUT only.
   */
  useV2ServiceWrites: process.env.REACT_APP_USE_V2_SERVICE_WRITES === "true",
  /**
   * Sidebar/editor totals from server snapshots (FE-P4-01 / FE-P4-02).
   * Default false. When true: v2 writes request `?includeTotals=true`, cards
   * update from write-response slices / `GET /v2/budget/:id/totals` keyed by
   * `totalsVersion`, and v1 PUT payloads omit client totals trees (server
   * owns them). Client calc remains display-only for line/card preview.
   * Flag off: client-computed totals trees sent on save as before.
   */
  useServerTotals: process.env.REACT_APP_USE_SERVER_TOTALS === "true",
  /**
   * Agrupamento no orçamento (MMV-2557): a visão "Por Agrupamento" e tudo o que
   * se chega por ela — criar/renomear/duplicar/excluir agrupamento, arrastar
   * linha entre eles e o formulário "Novo fornecedor em <agrupamento>".
   *
   * Desligada, a única porta de entrada (o alternador de visão) some e o modo
   * fica preso em "Por Fornecedor" — inclusive para quem já tinha escolhido a
   * visão agrupada antes, cuja preferência está no `localStorage`. O orçamento
   * abre exatamente como abria antes da funcionalidade.
   *
   * **Ocultar não é apagar.** `budgetGroups` e o `groupId` dos serviços
   * continuam no documento e voltam a aparecer quando a flag for religada: o
   * que a flag corta é a UI, não o dado. Nada no reducer roda sem uma ação da
   * tela, e as props de agrupamento do `BudgetItem` são opcionais — sem a visão
   * agrupada montada elas chegam `undefined`, que é o caminho de sempre.
   */
  budgetGroups: process.env.REACT_APP_BUDGET_GROUPS === "true",
};
